<mat-accordion>
    <mat-expansion-panel [expanded]="isExpanded">
        <mat-expansion-panel-header class="nova__expansion__header">
            <mat-panel-title class="flex-row justify-start items-center">
                <span class="nova__expansion__header__title-text">
                    {{header}}
                </span>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-content></ng-content>
    </mat-expansion-panel>
</mat-accordion>
